var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    { staticClass: "ma-0 pa-0" },
    [
      _c("l-add-group-popup", { ref: "l-add-group-popup" }),
      _c("l-edit-group-popup", { ref: "l-edit-group-popup" }),
      _c("l-add-key-popup", { ref: "l-add-key-popup" }),
      _c("l-edit-key-popup", { ref: "l-edit-key-popup" }),
      _c("l-merge-key-popup", { ref: "l-merge-key-popup" }),
      _c(
        "v-card",
        { staticClass: "pa-2", attrs: { elevation: "0", outlined: "" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mt-0" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    elevation: "0",
                    color: "green",
                    disabled: !_vm.ifCanCreateNewGroup(),
                  },
                  on: { click: _vm.addNewGroup },
                },
                [_vm._v(" New group "), _c("v-icon", [_vm._v("mdi-plus")])],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    elevation: "0",
                    color: "red",
                    loading: _vm.fixLocalizations,
                    disabled: !_vm.ifCanAddMissingKeys(),
                  },
                  on: { click: _vm.fixLocaleKeys },
                },
                [
                  _vm._v(" Add missing keys "),
                  _c("v-icon", { staticClass: "ml-2" }, [
                    _vm._v("mdi-auto-fix"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    elevation: "0",
                    color: "orange",
                    loading: _vm.exportingXms,
                    disabled: !_vm.ifCanExport(),
                  },
                  on: { click: _vm.exportAllLanguagesToServer },
                },
                [
                  _vm._v(
                    " Export (" +
                      _vm._s(
                        _vm.localizations.keys == null
                          ? 0
                          : Object.keys(_vm.localizations.keys).length
                      ) +
                      " keys) "
                  ),
                  _c("v-icon", { staticClass: "ml-2" }, [
                    _vm._v("mdi-database-export"),
                  ]),
                ],
                1
              ),
              _c(
                "v-card",
                {
                  staticClass: "ml-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "green--text",
                      attrs: {
                        icon: "",
                        elevation: "0",
                        color: "white",
                        loading: _vm.exportingJSON,
                        disabled: !_vm.ifCanExportJSON(),
                      },
                      on: { click: _vm.exportAllLanguagesToJSON },
                    },
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("mdi-file-export"),
                      ]),
                    ],
                    1
                  ),
                  _c("input", {
                    ref: "uploaderJson",
                    staticClass: "d-none",
                    attrs: { type: "file", accept: "application/JSON" },
                    on: { change: _vm.onFileChangedJson },
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "red--text",
                      attrs: {
                        icon: "",
                        elevation: "0",
                        color: "white",
                        loading: _vm.importingJSON,
                        disabled: !_vm.ifCanImportJSON(),
                      },
                      on: { click: _vm.onPressImportJSON },
                    },
                    [
                      _c("v-icon", { attrs: { color: "red" } }, [
                        _vm._v("mdi-file-import"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "pa-2", attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mt-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", elevation: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.expand(false)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { size: "20" } }, [
                    _vm._v("mdi-chevron-up"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", elevation: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.expand(true)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { size: "20" } }, [
                    _vm._v("mdi-chevron-down"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        _vm._l(_vm.getItems, function (item) {
          return _c(
            "v-card-actions",
            { key: item.key_id, staticClass: "ma-0 pa-0 mt-0" },
            [
              item.name != undefined
                ? [
                    _c(
                      "v-card",
                      {
                        staticClass: "mt-2",
                        attrs: {
                          elevation: "0",
                          outlined: "",
                          width: "100%",
                          color: item.color,
                        },
                      },
                      [
                        _c(
                          "v-card-actions",
                          { staticClass: "ma-0 pa-0" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  icon: "",
                                  color: "white",
                                  disabled: !_vm.ifCanAddKeyValue(),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addItemInGroup(item.group_id)
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-plus")])],
                              1
                            ),
                            _c(
                              "v-card-text",
                              { staticClass: "white--text ml-1 pa-1" },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", color: "white" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showHide(item)
                                  },
                                },
                              },
                              [
                                _vm.hidden.includes(item.group_id)
                                  ? _c("v-icon", { attrs: { size: "20" } }, [
                                      _vm._v("mdi-chevron-down"),
                                    ])
                                  : _c("v-icon", { attrs: { size: "20" } }, [
                                      _vm._v("mdi-chevron-up"),
                                    ]),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ml-0",
                                attrs: {
                                  icon: "",
                                  color: "white",
                                  disabled: !_vm.ifCanEditGroup(),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editGroup(item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("mdi-pencil-outline"),
                                ]),
                              ],
                              1
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  icon: "",
                                  color: "white",
                                  disabled: !_vm.ifCanDeleteGroup(),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteGroup(item.group_id)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { size: "20" } }, [
                                  _vm._v("mdi-delete"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "v-card",
                      { attrs: { width: "40%", elevation: "0" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mt-1 no-uppercase",
                            attrs: {
                              outlined: "",
                              width: "100%",
                              color: _vm.getGroupColor(item.group_id),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editKeyValue(
                                  item.group_id,
                                  item.key_id,
                                  item.key_name
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.key_name) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      {
                        staticClass: "ma-0 ml-2 mt-1",
                        attrs: { outlined: "", width: "100%" },
                      },
                      [_c("v-card-actions", [_vm._v(_vm._s(item.value))])],
                      1
                    ),
                  ],
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }